import { useRouter } from "next/router";
import React from "react";

const Loading = (props) => {
  const { locale } = useRouter();
  return (
    <>
      <div className={props.loading ? " loader-big fired" : "loader-big"}>
        <div className="cube-wrapper">
          <div className="cube-folding">
            <span className="leaf1"></span>
            <span className="leaf2"></span>
            <span className="leaf3"></span>
            <span className="leaf4"></span>
          </div>
          <span className="loading" data-name="Loading">
            {locale === "en" ? "Loading..." : "جاري التحميل..."}
          </span>
        </div>
      </div>
    </>
  );
};

export default Loading;
